const userUtils = {
  data () {
    return {
    }
  },
  methods: {
    someMethod () {
    }
  },
  computed: {
    isAdminOrSuperAdmin () {
      return this.$store.state.User.user.Roles.find(role => role.name.indexOf('admin') > -1)
    },
    isManager () {
      return this.$store.state.User.user.Roles.find(role => role.name.indexOf('manager') > -1)
    },
    isSuperAdmin () {
      return this.$store.state.User.user.Roles.find(role => role.name.indexOf('superadmin') > -1)
    },
    currentUserNetwork () {
      return this.$store.state.User.user.Networks.find(network => network.id === this.$store.state.User.user.lastNetworkId)
    }
  }
}
export default userUtils



// WEBPACK FOOTER //
// ./src/components/Common/userUtils.mixin.js